<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" fill="none" viewBox="0 0 14 11"><path fill="#516783" d="M13.575 3.994C12.671 2.521 10.613.05 7.001.05 3.389.049 1.33 2.52.426 3.994a2.863 2.863 0 0 0 0 3.012C1.33 8.479 3.389 10.95 7 10.95s5.67-2.472 6.574-3.945a2.863 2.863 0 0 0 0-3.012Zm-.994 2.4c-.777 1.264-2.536 3.39-5.58 3.39-3.045 0-4.804-2.126-5.58-3.39a1.702 1.702 0 0 1 0-1.789c.776-1.263 2.535-3.39 5.58-3.39 3.044 0 4.803 2.124 5.58 3.39a1.702 1.702 0 0 1 0 1.79Z"/><path fill="#516783" d="M7 2.583a2.917 2.917 0 1 0 0 5.834 2.917 2.917 0 0 0 0-5.834ZM7 7.25a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5Z"/></svg>
</template>
<script>
export default {
  name: "IconEye"
}
</script>